/**
 * --------------------------------------------------------------------------
 * Basic Modules: TinySlider.js
 * --------------------------------------------------------------------------
 */

import Util from "./../util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'tinySlider';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const SliderSettings = {
    mode                : 'carousel',
    axis                : 'horizontal',
    items               : 1,
    gutter              : 0,
    edgePadding         : 0,
    fixedWidth          : false,
    autoWidth           : false,
    viewportMax         : false,
    slideBy             : 1,
    center              : false,
    controls            : true,
    controlsPosition    : 'top',
    controlsText        : ['prev', 'next'],
    controlsContainer   : false,
    prevButton          : false,
    nextButton          : false,
    nav                 : true,
    navPosition         : 'top',
    navContainer        : false,
    navAsThumbnails     : false,
    arrowKeys           : false,
    speed               : 300,
    autoplay            : false,
    autoplayPosition    : 'top',
    autoplayTimeout     : 5000,
    autoplayDirection   : 'forward',
    autoplayText        : ['start', 'stop'],
    autoplayHoverPause  : false,
    autoplayButton      : false,
    autoplayButtonOutput        : true,
    autoplayResetOnVisibility   : true,
    animateIn           : 'tns-fadeIn',
    animateOut          : 'tns-fadeOut',
    animateNormal       : 'tns-normal',
    animateDelay        : false,
    loop                : true,
    rewind              : false,
    autoHeight          : false,
    responsive          : false,
    lazyload            : false,
    lazyloadSelector    : '.tns-lazy-img',
    touch               : true,
    mouseDrag           : false,
    swipeAngle          : 15,
    preventActionWhenRunning    : false,
    preventScrollOnTouch        : false,
    nested              : false,
    freezable           : true,
    disable             : false,
    startIndex          : 0,
    onInit              : false,
    useLocalStorage     : true,
};

const Default = {};

const ClassName = {};

const Selector = {
    TOGGLE              : '[data-tiny-slider]',
};

class TinySlider {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this._element      = element;
        this._config       = this._getConfig(config);
        this._sliderConfig = this._getSliderConfig(this._config);

        DEBUG && console.log(LOG_KEY, 'Slider Config', this._config);
        DEBUG && console.log(LOG_KEY, 'Slider Settings', this._sliderConfig);

        this._setup();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _setup() {

        let firstAnimatingElems = $(this._element)
                .find('.first')
                .find('[data-animation^="animated"]');

        let slider = tns(this._sliderConfig);

        // Apply the animation to the first item using the doAnimations() function
        this._doAnimations(firstAnimatingElems);

        slider.events.on('indexChanged', (info, EventName) => {
            // Select the elements to be animated inside the active slide
            //console.log(slick);
            let slides = info.slideItems;
            let currentIndex = info.index;
            let currentSlide = slides[currentIndex];

            let animatingElems = $(currentSlide).find('[data-animation^="animated"]');
            this._doAnimations(animatingElems);
        });
    }

    _doAnimations(elems) {

        const self = this;
        let animEndEv = Util.whichAnimationEvent() + '.tinySlide';

        //DEBUG && console.log(LOG_KEY, 'Starting the animation');

        elems.each(function(idx, elem)
        {
            let animationType = $(elem).data('animation');

            // Add animate.css classes to
            // the elements to be animated
            // Remove animate.css classes
            // once the animation event has ended
            $(elem).addClass(animationType).one(animEndEv, () => {
                $(elem).removeClass(animationType);
            });
        });
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _getSliderConfig(config) {

        // step through the config options, and check if they are present in the default slick settings,
        // and only use them if the new settings differ from the default ones
        let sliderSettings = {
            container: Selector.TOGGLE,
            //controlsPosition: 'bottom',
        };

        const entries = Object.entries(config);
        for (const [property, value] of entries) {
            //DEBUG && console.log(LOG_KEY, 'Slick Property/value', property, '/', value);
            if (SliderSettings[property] !== undefined && SliderSettings[property] !== value) {
                sliderSettings[property] = value;
            }
        }

        return sliderSettings;
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        TinySlider._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new TinySlider(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = TinySlider._jQueryInterface;
$.fn[NAME].Constructor = TinySlider;


export default TinySlider;
